<template>
  <div class="root">
    <div v-for="discussion in discussionList" :key="discussion.id" class="discussion-card">
      <div class="author-container">
        <div
          :style="`background-image: url(${discussion.author_info.avatar});`"
          class="avatar-img"
        />
        <div class="avatar-text">
          <span class="author-name">{{ discussion.author_info.full_name }}</span>
          <span class="publish-time">{{ discussion.release_time }}</span>
        </div>
      </div>

      <h2 class="title-text">{{ discussion.name }}</h2>

      <MarkdownDisplay :value="discussion.description" withMaxHeight noShadow />
      <FileDownloadCard v-if="discussion.attachment" :href="discussion.attachment" />
      <div class="card-footer">
        <router-link :to="'/class/'+ $route.params.class_id + '/discussions/' + discussion.id">
          <span class="icon-container">
            <i class="el-icon-more"></i>
            <span>View Details</span>
          </span>
        </router-link>
        <span class="icon-container">
          <i class="el-icon-s-comment"></i>
          <span>Comments {{ discussion.comments.length }}</span>
        </span>
        <span
          class="icon-container"
          v-if="discussion.author_info.id === $store.state.userId"
          @click="removeDiscussion(discussion.id)"
        >
          <i class="el-icon-delete-solid"></i>
          <span>Delete</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteDiscussion } from "@/api";
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";

export default {
  name: "DiscussionRecordList",
  components: {
    MarkdownDisplay,
    FileDownloadCard
  },
  props: {
    discussionList: Array
  },
  methods: {
    removeDiscussion(discussion_id) {
      deleteDiscussion(discussion_id);
      this.$emit("refresh-list");
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  .discussion-card {
    margin-top: 16px;
    padding: 32px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background-color: #ffffff;
    .title-text {
      flex-grow: 1;
    }
    .author-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 12px;
      padding: 4px 0;
      .avatar-img {
        width: 32px;
        height: 32px;
        background-position: center 10%;
        background-size: cover;
        border: 1px rgba(0, 0, 0, 0.25) solid;
        border-radius: 50%;
        overflow: hidden;
      }
      .avatar-text {
        flex-grow: 1;
        height: 32px;
        line-height: 32px;
        > span {
          height: 100%;
          vertical-align: middle;
        }
        .author-name {
          margin-left: 16px;
          font-size: 14px;
          font-weight: 600;
        }
        .publish-time {
          color: rgba(0, 0, 0, 0.25);
          font-size: 12px;
          margin-left: 24px;
          float: right;
        }
      }
    }
    .card-footer {
      margin-top: 16px;
      margin-bottom: 48px;
      .icon-container {
        > i {
          margin-right: 8px;
        }
        cursor: pointer;
        color: #909399;
        margin-left: 48px;
        float: right;
      }
    }
  }
}
</style>